export default "__VITE_ASSET__36c37d05__"